import BaseService from '@/ecm/common/BaseService.js';

class CommentService {
  baseUrl = 'comment';

  getList = (documentId) => BaseService.get({ url: `${this.baseUrl}/get-list/${documentId}` });
  remove = (id) => BaseService.post({ url: `${this.baseUrl}/remove/${id}` });
  save = (comment) => BaseService.post({ url: `${this.baseUrl}/save-comment`, data: comment });
}

export default new CommentService();
